var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable indent */
import styled, { css } from 'styled-components';
var getHorizontalAlignment = function getHorizontalAlignment(align) {
  switch (align) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    case 'justify':
      return 'space-between';
    default:
      return 'flex-start';
  }
};
var getVerticalAlignment = function getVerticalAlignment(align) {
  switch (align) {
    case 'top':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'bottom':
      return 'flex-end';
    case 'stretch':
    default:
      return 'stretch';
  }
};
export default styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme,
    $alignX = _ref2.$alignX,
    $alignY = _ref2.$alignY,
    $reversed = _ref2.$reversed;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      align-items: ", ";\n      display: flex;\n      flex-direction: ", ";\n      flex-wrap: wrap;\n      flex-grow: 0;\n      justify-content: ", ";\n      margin-left: calc(", " / -2);\n      margin-right: calc(", " / -2);\n    "])), getVerticalAlignment($alignY), $reversed ? 'row-reverse' : 'row', getHorizontalAlignment($alignX), theme.grid_gutter_width, theme.grid_gutter_width);
});